import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class Post extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    advisor: PropTypes.object,
    social_campaign: PropTypes.object
  }

  state = {
    config: {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  state = {
    config: {}
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    const { advisor, social_campaign } = this.props
    return {
      title: 't(Repost Social Campaign)',
      action: `/api/admin/truevail/admin/advisors/${advisor.id}/social_campaigns/${social_campaign.id}/repost`,
      method: 'PATCH',
      saveText: 't(Repost)',
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Send At)', type: 'segment', fields: [
              { name: 'strategy', type: 'radiogroup', options: [
                { value: 'now', text: 't(Post immediately)' },
                { value: 'schedule', text: 't(Schedule Post)' }
              ], defaultValue: 'now', required: true },
              { name: 'post_at', type: 'datetimefield', show: config.strategy === 'schedule', required: true }
            ] }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Post
